import {} from 'react';
import { ModalBody } from '../../../ModalComponent/ModalBody/ModalBody';
import { PersonalDetails } from './PersonalDetails/PersonalDetails';
import { EducationWorkExperience } from './EducationWorkExperience/EducationWorkExperience';
import { LanguagesComponent } from './LanguagesComponent/LanguagesComponent';

import { DETAILED_INFO_MODAL_VARIABLES } from '../../../../../../../../../config';
import { ObjectType } from '../../../../../../../../../types/objectType';

export const CVInfo = (
  {
    modalDetailedInfo,
    detailLoading,
  }: ObjectType,
) => (
  <ModalBody>
    <PersonalDetails modalDetailedInfo={modalDetailedInfo} />
    <EducationWorkExperience
      modalDetailedInfo={modalDetailedInfo}
      type={DETAILED_INFO_MODAL_VARIABLES.education}
      detailLoading={false}
    />
    <EducationWorkExperience
      modalDetailedInfo={modalDetailedInfo}
      type={DETAILED_INFO_MODAL_VARIABLES.workExperience}
      detailLoading={detailLoading}
    />
    <EducationWorkExperience
      modalDetailedInfo={modalDetailedInfo}
      type={DETAILED_INFO_MODAL_VARIABLES.certificates}
      detailLoading={false}
    />
    <EducationWorkExperience
      modalDetailedInfo={modalDetailedInfo}
      type={DETAILED_INFO_MODAL_VARIABLES.formations}
      detailLoading={false}
    />
    <EducationWorkExperience
      modalDetailedInfo={modalDetailedInfo}
      type={DETAILED_INFO_MODAL_VARIABLES.courses}
      detailLoading={false}
    />
    <LanguagesComponent
      modalDetailedInfo={modalDetailedInfo}
      type={DETAILED_INFO_MODAL_VARIABLES.languages}
      detailLoading={false}
    />
  </ModalBody>);
